// Qisqa xabarlar ("Saqlandi ✓"): ish bajarilganini ko'rsatadi va kerak bo'lsa "Qaytarish" imkonini beradi.
// Har joydan chaqiriladi: toast('Saqlandi') yoki toast('Arxivga olindi', { undo: () => ... }).
// Ilovada bitta <Toaster /> turadi (ekran pastida, telefonda pastki menyudan yuqorida).
import { useEffect, useState } from 'react';
import { Icon } from './icons';

export type ToastTone = 'success' | 'info' | 'danger';

export interface ToastOptions {
  tone?: ToastTone;
  /** Amalni bekor qilish: tugma bosilsa chaqiriladi */
  undo?: () => unknown;
  undoLabel?: string;
}

interface ToastItem extends ToastOptions {
  id: number;
  text: string;
  busy?: boolean;
}

let items: ToastItem[] = [];
let seq = 0;
const listeners = new Set<(list: ToastItem[]) => void>();

function emit() {
  for (const l of listeners) l(items);
}

export function dismissToast(id: number) {
  if (!items.some((t) => t.id === id)) return;
  items = items.filter((t) => t.id !== id);
  emit();
}

/** Xabar chiqaradi. Bir vaqtda ko'pi bilan 3 ta; qaytarish tugmasi bo'lsa — uzoqroq turadi. */
export function toast(text: string, opts: ToastOptions = {}): number {
  const id = ++seq;
  items = [...items.slice(-2), { id, text, tone: opts.tone ?? 'success', undo: opts.undo, undoLabel: opts.undoLabel }];
  emit();
  setTimeout(() => dismissToast(id), opts.undo ? 7000 : opts.tone === 'danger' ? 6000 : 3500);
  return id;
}

async function runUndo(t: ToastItem) {
  if (!t.undo || t.busy) return;
  items = items.map((x) => (x.id === t.id ? { ...x, busy: true } : x));
  emit();
  try {
    await t.undo();
    dismissToast(t.id);
    toast('Qaytarildi', { tone: 'info' });
  } catch (e) {
    dismissToast(t.id);
    toast(e instanceof Error ? e.message : 'Qaytarib bo‘lmadi', { tone: 'danger' });
  }
}

export function Toaster() {
  const [list, setList] = useState<ToastItem[]>(items);
  useEffect(() => {
    listeners.add(setList);
    setList(items);
    return () => {
      listeners.delete(setList);
    };
  }, []);
  return (
    <div className="op-toasts" role="status" aria-live="polite">
      {list.map((t) => (
        <div key={t.id} className={`op-toast op-toast--${t.tone ?? 'success'}`}>
          <span className="op-toast__icon" aria-hidden="true">
            <Icon name={t.tone === 'danger' ? 'alert' : 'check'} />
          </span>
          <span className="op-toast__text">{t.text}</span>
          {t.undo && (
            <button type="button" className="op-toast__undo" disabled={t.busy} onClick={() => void runUndo(t)}>
              {t.busy ? '…' : (t.undoLabel ?? 'Qaytarish')}
            </button>
          )}
          <button type="button" className="op-toast__close" aria-label="Xabarni yopish" onClick={() => dismissToast(t.id)}>
            <Icon name="x" />
          </button>
        </div>
      ))}
    </div>
  );
}
